import { NAV_SECTIONS, ROLE_PAGE_ACCESS } from "./constants";

function normalizeRoleKey(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function getUserRoleKey(user = {}) {
  return normalizeRoleKey(
    user?.roleKey || user?.raw?.role || user?.roles?.[0] || ""
  );
}

export function isAdminUser(user = {}) {
  return getUserRoleKey(user) === "admin";
}

export function isCallingAgentUser(user = {}) {
  return getUserRoleKey(user) === "calling_agent";
}

export function canAccessPage(user, pageId) {
  const roleKey = getUserRoleKey(user);
  const normalizedPageId = String(pageId || "").trim().toLowerCase();

  if (!roleKey || !normalizedPageId) {
    return false;
  }

  const allowedPages = ROLE_PAGE_ACCESS[roleKey] || [];
  return allowedPages.includes(normalizedPageId);
}

export function filterNavSectionsForUser(user, navSections = NAV_SECTIONS) {
  return navSections
    .map((section) => ({
      ...section,
      items: (section.items || []).filter((item) => canAccessPage(user, item.id)),
    }))
    .filter((section) => section.items.length);
}
